import React from "react";
import AppLayout from "../components/AppLayout";
import { FileText } from "lucide-react";

function Section({ title, children, isDark }) {
  return (
    <section
      className={`rounded-3xl border p-6 shadow-sm ${
        isDark ? "border-slate-800 bg-slate-900" : "border-slate-200 bg-white"
      }`}
    >
      <h2 className={`text-lg font-semibold ${isDark ? "text-white" : "text-slate-900"}`}>
        {title}
      </h2>
      <div className={`mt-3 space-y-3 text-sm leading-7 ${isDark ? "text-slate-300" : "text-slate-600"}`}>
        {children}
      </div>
    </section>
  );
}

export default function TermsPage({ isDark, setIsDark, currency, setCurrency }) {
  return (
    <AppLayout
      isDark={isDark}
      setIsDark={setIsDark}
      currency={currency}
      setCurrency={setCurrency}
      eyebrow="Legal"
      title="Terms of Use"
      description="Core terms governing use of the SpaceM8 platform."
    >
      <div className="space-y-6">
        <div
          className={`rounded-3xl border p-5 shadow-sm ${
            isDark ? "border-slate-800 bg-slate-900" : "border-slate-200 bg-white"
          }`}
        >
          <div className="flex items-center gap-3 text-sky-700">
            <FileText className="h-5 w-5" />
            <span className="font-medium">Use of the platform</span>
          </div>
          <p className={`mt-3 text-sm leading-7 ${isDark ? "text-slate-300" : "text-slate-600"}`}>
            By using SpaceM8, you agree to use the platform responsibly, protect access credentials, and comply with applicable operational policies.
          </p>
        </div>

        <Section title="Account responsibilities" isDark={isDark}>
          <p>Users are responsible for maintaining the confidentiality of their login information and any activity performed through their account.</p>
          <p>Administrative users must manage permissions carefully and restrict access appropriately.</p>
        </Section>

        <Section title="Acceptable use" isDark={isDark}>
          <p>The platform must not be used for unlawful activity, unauthorized data access, abusive messaging, or misuse of AI-generated recommendations.</p>
          <p>Users should validate important operational decisions before execution.</p>
        </Section>

        <Section title="Service availability" isDark={isDark}>
          <p>We aim to provide reliable service, but uninterrupted access is not guaranteed at all times.</p>
          <p>Features, workflows, or UI elements may change as the platform develops.</p>
        </Section>

        <Section title="Limitation and updates" isDark={isDark}>
          <p>Use of the platform is at your organization’s discretion and responsibility.</p>
          <p>These terms may be updated periodically to reflect product, legal, or operational changes.</p>
        </Section>
      </div>
    </AppLayout>
  );
}